import Link from './Link'
import { getCategories } from '../data/products'

const Footer = () => {
  const categories = getCategories()

  return (
    <footer className="border-t border-slate-800 bg-slate-950 text-slate-400">
      <div className="container mx-auto px-4 py-10">
        <div className="grid gap-8 md:grid-cols-[1.2fr_1fr]">
          <div>
            <Link to="/" className="flex items-center gap-3" ariaLabel="Angel Technology home">
              <img
                src="/images/brand-mark.svg"
                alt="Angel Technology"
                className="h-9 w-9 brightness-0 invert"
              />
              <span className="text-sm font-semibold uppercase tracking-[0.2em] text-white">
                Rehab Solutions
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-7">
              Prosthetic components, orthotic products and rehabilitation materials supplied to
              distributors, clinics and rehabilitation centres worldwide.
            </p>
          </div>

          <nav aria-label="Product categories">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              Product categories
            </p>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {categories.map(({ category, slug }) => (
                <li key={slug}>
                  <Link
                    to={`/category/${slug}`}
                    className="transition-colors hover:text-teal-300"
                  >
                    {category}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <p className="mt-8 border-t border-slate-800 pt-6 text-sm">
          © 2026 Angel Technology International Co., Ltd. Product information for global buyers.
        </p>
      </div>
    </footer>
  )
}

export default Footer
